/**
 * Adds a fixed bundle of line items to the cart in one request and hands the
 * response to the theme's cart drawer (<mini-cart>), matching how
 * ProductForm in global.js behaves on a normal product page.
 *
 * An instance with no items of its own reuses the items of the first instance
 * on the page that has them, so a second call-to-action further down the page
 * always adds exactly the same bundle.
 */
class EtGlowBundleAtc extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';

    this.button = this.querySelector('[data-atc]');
    this.errorEl = this.querySelector('[data-error]');
    this.labelEl = this.querySelector('[data-atc-label]');
    if (!this.button) return;

    this.idleLabel = this.labelEl ? this.labelEl.textContent : '';
    this.button.addEventListener('click', this.onClick.bind(this));

    if (!this.ownItems.length && !this.inheritsItems) this.button.disabled = true;
  }

  get inheritsItems() {
    return this.hasAttribute('data-inherit-items');
  }

  get ownItems() {
    const script = this.querySelector('[data-items]');
    if (!script) return [];
    try {
      const parsed = JSON.parse(script.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  get items() {
    if (this.ownItems.length) return this.ownItems;
    if (!this.inheritsItems) return [];

    const donors = document.querySelectorAll('et-glow-bundle-atc');
    for (let i = 0; i < donors.length; i += 1) {
      if (donors[i] === this) continue;
      const items = donors[i].ownItems;
      if (items.length) return items;
    }
    return [];
  }

  get miniCart() {
    return document.querySelector('mini-cart');
  }

  get useDrawer() {
    return Boolean(
      this.miniCart &&
        window.shopSettings &&
        window.shopSettings.cartDrawer &&
        !document.body.classList.contains('template-cart')
    );
  }

  setLoading(isLoading) {
    this.button.disabled = isLoading;
    this.button.classList.toggle('loading', isLoading);
    if (!this.labelEl) return;
    const loadingLabel = this.dataset.loadingLabel;
    this.labelEl.textContent = isLoading && loadingLabel ? loadingLabel : this.idleLabel;
  }

  showError(message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message;
    this.errorEl.hidden = !message;
  }

  onClick() {
    const items = this.items;
    if (!items.length || this.button.disabled) return;

    this.showError('');
    this.setLoading(true);

    const miniCart = this.miniCart;
    const useDrawer = this.useDrawer;
    const body = { items: items, sections_url: window.location.pathname };
    if (useDrawer) {
      body.sections = miniCart
        .getSectionsToRender()
        .map(function (section) {
          return section.id;
        })
        .join(',');
    }

    const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || '');
          }
          return data;
        });
      })
      .then((data) => {
        if (useDrawer) {
          miniCart.renderContents(data);
          this.setLoading(false);
          return;
        }
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      })
      .catch((error) => {
        this.setLoading(false);
        this.showError(error.message || this.dataset.errorLabel || '');
      });
  }
}

if (!customElements.get('et-glow-bundle-atc')) {
  customElements.define('et-glow-bundle-atc', EtGlowBundleAtc);
}
